// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FacebookDisabledPage-cls1___74c04c1a1027ebdbfec{/*!*/}.FacebookDisabledPage-cls2___5457bd723e42af1819a{display:flex;flex-direction:column;align-items:center;justify-content:center;grid-gap:24px;gap:24px;max-width:540px;text-align:center;line-height:1.5}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "FacebookDisabledPage-cls1___74c04c1a1027ebdbfec",
	"cls2": "FacebookDisabledPage-cls2___5457bd723e42af1819a FacebookDisabledPage-cls1___74c04c1a1027ebdbfec"
};
export default ___CSS_LOADER_EXPORT___;
